<!--
 * @Author: your name
 * @Date: 2020-04-23 17:57:27
 * @LastEditTime: 2021-05-26 11:39:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \szny-official-website\src\components\Header\index.vue
-->
<template>
    <div class="page-header ui-flex ui-flex-justify-center">
        <!-- 导航 -->
        <div class="ele-wrap page-nav ui-flex ui-flex-justify-space-between ui-flex-align-center">
            <div class="nav-logo"></div>
            <ul class="nav-list ui-flex ui-flex-justify-center ui-flex-align-center">
                <li v-for="(v) in navs" :key="v.id" class="list-li " :class="{ 'list-li-active': v.isActive }"
                    @click="jump(v)">
                    {{ v.name }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import router from '@/router'
    export default {
        props: ['path'],
        name: 'Header',
        data() {
            return {
                navs: [
                    { id: 0, name: '首页', path: '/', isActive: true, },
                    { id: 1, name: '关于我们', path: '/about', isActive: false, },
                    { id: 2, name: '产品中心', path: '/productCenter', isActive: false, },
                    // { id: 3, name: '企业动态', path: '/information', isActive: false, },
                    { id: 4, name: '免费试用', path: '/try', isActive: false, },
                    { id: 5, name: '联系我们', path: '/contactUs', isActive: false, },
                ],
            }
        },
        created(){
            //初始化导航样式
            this.navs.map((v, i, a) => {
                        if (this.path === v.path) {
                            v.isActive = true
                        } else {
                            v.isActive = false
                        }

                    }) 
        },
        methods: {
            /**
             * 导航点击跳转
            */
            jump(value) {
                if (value.path) {
                    router.push({
                        path: value.path,
                    }).catch(err => {
                        console.log(err)
                    })
                    
                }

            }
        }, 
        
    }
</script>

<style lang="scss">
    @import './style.scss'
</style>